 import React from "react";

export default function PosLogo() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 23" fill="none">
        <path
          d="M21.6 11.7517C21.6 17.6059 16.8542 22.3517 11 22.3517C5.14578 22.3517 0.4 17.6059 0.4 11.7517C0.4 5.89749 5.14578 1.15171 11 1.15171C16.8542 1.15171 21.6 5.89749 21.6 11.7517Z"
          fill="white" stroke="#9D9D9D" strokeWidth="0.8" />
        <ellipse cx="11" cy="11.7517" rx="4.125" ry="4.125" fill="#5842BE" />
      </svg>
    </>
  );
}
